import abTests from 'frontend/shared/javascripts/modules/ab_tests'
import safeLocalStorage from 'frontend/shared/javascripts/util/safe_local_storage'

export const STORAGE_KEY = 'lastPageloadAt'
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000

export function trackSessionStart() {
  const lastPageloadAt = Number(safeLocalStorage().getItem(STORAGE_KEY)) || 0
  const isNewSession = Date.now() - lastPageloadAt > SESSION_TIMEOUT_MS

  if (isNewSession) {
    abTests.conversion('session_start')
  }

  safeLocalStorage().setItem(STORAGE_KEY, String(Date.now()))
}
